import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '@Container/common/client/utils/rel';
/**
 * 定义 Nav 组件
 */
class pitHeader extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        // console.log(this.props)
        const { content } = this.props;

        const nav = (
            <ul>
                {content.map((item, index) => {
                    if (index === 0) {
                        return (
                            <li key={item.name}>
                                <a
                                    href={item.url}
                                    target="_blank"
                                    title={item.title}
                                    className={styles.active}
                                    rel={rel}>
                                    {item.title}
                                    <br />
                                    <span>{item.name}</span>
                                </a>
                            </li>
                        );
                    } else {
                        return (
                            <li key={item.name}>
                                <a href={item.url} target="_blank" title={item.title} rel={rel}>
                                    {item.title}
                                    <br />
                                    <span>{item.name}</span>
                                </a>
                            </li>
                        );
                    }
                })}
            </ul>
        );

        return (
            <div className={styles.menu}>
                <div className={styles.menu_w1000}>
                    <div className={styles.logo}>
                        <a href="https://pit.ifeng.com/">
                            <img
                                src="//p3.ifengimg.com/a/2017_38/48e3bbe5ff20678.png"
                                title="logo"
                                alt="凤凰网国际智库"
                                rel={rel}
                            />
                        </a>
                    </div>
                    <div className={styles.menu_r}>{nav}</div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(pitHeader);
